<kodit-dropdown
  [options]="items"
  [formCtrl]="periodCtrl"
  (optionChanged)="handleOnItemChange($event)"
></kodit-dropdown>
